import { ElementType, MutableRefObject } from 'react';

export type FiltersProps = {
  bannerRef: MutableRefObject<HTMLDivElement>;
};

export enum SearchFilterColors {
  orange = '#F97316',
  yellow = '#FACC15',
  purple = '#5A00EE',
  brown = '#795F50',
  black = '#000000',
  white = '#FFFFFF',
  green = '#2BBA5F',
  blue = '#0069EF',
  pink = '#EC488D',
  gray = '#7C7C7C',
  red = '#E40C0C',
}

export enum FiltersTypes {
  orientations = 'orientations',
  colors = 'colors',
  subCategories = 'subCategories',
  type = 'animation_type',
  price = 'is_paid',
  theme = 'theme',
  size = 'size',
}

export type FiltersDataType = {
  queryName: FiltersTypes;
  title: string;
  options: Array<{
    label: string;
    value: string;
    startIcon?: ElementType;
  }>;
};
